export const SpektraServices = [
    {
        Summary: 'Investment Planning',
        Details: [
            {
                Item: 'Saving for different Goals',
                Sublist: [
                    { Item: 'Overseas holiday' },
                    { Item: 'A New Car' },
                    { Item: 'Children’s education' }
                ]
            },
            {
                Item: 'Putting an emergency fund in place',
                Sublist: [{ Item: 'For when Life happens…' }]
            }
        ]
    },
    {
        Summary: 'Retirement Planning',
        Details: [{ Item: 'Worry Free Retirement' }]
    },
    {
        Summary: 'Offshore Investments',
        Details: [{ Item: 'Diversifying your investments' }]
    },
    {
        Summary: 'Medical Aids',
        Details: [{ Item: 'Basic to Comprehensive Cover' }]
    },
    {
        Summary: 'Individual Risk Planning',
        Details: [
            { Item: 'Whole Life Cover', ListItem: true },
            { Item: 'Term Life Cover', ListItem: true },
            { Item: 'Disability Cover', ListItem: true },
            { Item: 'Income Protection', ListItem: true },
            { Item: 'Trauma Cover', ListItem: true },
            { Item: 'Retrenchment Cover', ListItem: true }
        ]
    },
    {
        Summary: 'Group Risk Cover',
        Details: [
            { Item: 'Life Cover', ListItem: true },
            { Item: 'Lump Sum Disability Cover', ListItem: true },
            { Item: 'Income Protection', ListItem: true },
            { Item: 'Trauma & Disease Cover', ListItem: true },
            { Item: 'Funeral Cover', ListItem: true }
        ]
    }
];
